import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { ControlIcons } from 'owa-control-icons';
let styles = require('./InfoBarMessage.scss');

export interface InfoBarMessageInfoIconProps {
    toolTipMessage: string;
}

const InfoBarMessageInfoIcon = (props: InfoBarMessageInfoIconProps) => {
    return (
        <span className={styles.infoIcon}>
            <TooltipHost content={props.toolTipMessage}>
                <Icon iconName={ControlIcons.Info} />
            </TooltipHost>
        </span>
    );
};

export default InfoBarMessageInfoIcon;
